import {
  DTOPageRedirectDeleteResponse,
  DTOPageRedirectListResponse,
  DTOPageRedirectResponse,
  DTOPageRedirectCreateBody,
  DTOPageRedirectUpdateBody,
} from "../../dto/design-systems/redirects";
import { RequestExecutor } from "../../transport/request-executor";

export class DesignSystemPageRedirectsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  create(dsId: string, body: DTOPageRedirectCreateBody) {
    return this.requestExecutor.json(`/design-systems/${dsId}/documentation/redirects`, DTOPageRedirectResponse, {
      body,
      method: "POST",
    });
  }

  list(dsId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/documentation/redirects`, DTOPageRedirectListResponse, {
      method: "GET",
    });
  }

  update(dsId: string, redirectId: string, body: DTOPageRedirectUpdateBody) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/documentation/redirects/${redirectId}`,
      DTOPageRedirectResponse,
      {
        body,
        method: "PUT",
      }
    );
  }

  delete(dsId: string, redirectId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/documentation/redirects/${redirectId}`,
      DTOPageRedirectDeleteResponse,
      {
        method: "DELETE",
      }
    );
  }
}
